import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import LoginPage from "./DistributorPanel/Login";
import DistributorPanel from "./DistributorPanel/DistributorPanel";

// Nested pages
import Dashboard from "./DistributorPanel/Dashboard";
import Retailers from "./DistributorPanel/Retailers";
import Keys from "./DistributorPanel/Keys";
import Inventory from "./DistributorPanel/Inventory";
import Orders from "./DistributorPanel/Orders";
import Payments from "./DistributorPanel/Payment";
import Balances from "./DistributorPanel/Balances";
import Support from "./DistributorPanel/Support";
import Account from "./DistributorPanel/Account";
import Invoices from "./DistributorPanel/Invoices";
import UserViewPage from "./DistributorPanel/UserViewPage";

function App() {
  return (
    <>
    <Router>
      <Routes>
        {/* Login */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected panel routes */}
        <Route path="/" element={<DistributorPanel />}>
          {/* Default redirect to dashboard */}
          <Route index element={<Navigate to="/dashboard" replace />} />

          <Route path="dashboard" element={<Dashboard />} />
          <Route path="allretailers" element={<Retailers />} />
          <Route path="keys" element={<Keys />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="orders" element={<Orders />} />
          <Route path="payments" element={<Payments />} />
          <Route path="balances" element={<Balances />} />
          <Route path="support" element={<Support />} />
          <Route path="account" element={<Account />} />
          <Route path="invoices" element={<Invoices/>} />
          <Route
           path="/dashboard/user/:id"
          element={
              <UserViewPage />
          }
        />
        </Route>

        {/* Catch all → go to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
     <ToastContainer position="bottom-right" />
    </>
    
    
  );
}

export default App;


// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// // Import your pages
// import Dashboard from "./DistributorPanel/Dashboard";
// import LoginPage from "./DistributorPanel/Login";
// import DistributorPanel from "./DistributorPanel/DistributorPanel";

// function App() {

//   return (
//     <Router>
//       <Routes>
//         <Route path="/login" element={<LoginPage />} />

//         <Route
//           path="/dashboard"
//           element={<DistributorPanel />}
//         />

//         <Route path="*" element={<Navigate to="/login" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// *************************** 25 SEPT 2025 ORIGINAL CODE **********************************************

// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// // Import your pages
// import Dashboard from "./DistributorPanel/Dashboard";
// import LoginPage from "./DistributorPanel/Login";
// import DistributorPanel from "./DistributorPanel/DistributorPanel";

// function App() {
//   const isAuthenticated = false; // Replace with real auth logic

//   return (
//     <Router>
//       <Routes>
//         {/* Public Route */}
//         <Route path="/login" element={<LoginPage />} />

//         {/* Protected Route */}
//         <Route
//           path="/dashboard"
//           element={
//             isAuthenticated ? <DistributorPanel /> : <Navigate to="/login" replace />
//           }
//         />

//         {/* Default/fallback route */}
//         <Route path="*" element={<Navigate to="/login" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;


// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
